import { defineView } from "eddev/views"

export default defineView("_error", (props) => {
  return (
    <div className="grid-auto">
      <div className="col-span-12 py-10">
        <h1 className="type-title-l">{props.title}</h1>
        <p className="type-body-l">{props.userMessage}</p>
      </div>
    </div>
  )
})
